import React from 'react';

const AdvertisementCard = ({ item }) => {
    const adImage =
        item && item.id && item.firstMediaFileReadModel ? item.firstMediaFileReadModel : undefined;
    const adImageBackground = adImage
        ? {
              backgroundImage: `url("${adImage.mediaFileImagePath}")`,
          }
        : undefined;
    const showActualAd = adImage ? true : false;
    const adNavigateTo = item ? item.navigateTo : undefined;
    const openInNewTab = (url) => {
        console.log('[AdvertisementCard] [openInNewTab] ' + url);
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };
    return (
        <>
            {showActualAd ? (
                <>
                    <div
                        id="saasappAdvertisementPlaceholder"
                        onClick={() => openInNewTab(adNavigateTo)}
                        className="col-12 col-md-6 d-flex align-items-stretch cursor-pointer"
                    >
                        <div className="card saasapp-card w-100 mb-3 overflow-hidden">
                            {adImage && (
                                <div
                                    className="saasapp-ad-img-card"
                                    style={adImageBackground}
                                    alt={adImage.mediaFileName}
                                ></div>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div
                        id="saasappAdvertisementPlaceholder"
                        onClick={() => openInNewTab('/advertise-with-us')}
                        className="col-12 col-md-6 d-flex align-items-stretch cursor-pointer"
                    >
                        <div className="card saasapp-card w-100 mb-3 overflow-hidden">
                            <div
                                className="saasapp-ad-img-card saasapp-ad-img-card--placeholder"
                                alt="Ad"
                            ></div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default AdvertisementCard;
